import { render, staticRenderFns } from "./flowchart-node.html?vue&type=template&id=07c4e934&"
import script from "./flowchart-node.ts?vue&type=script&lang=ts&"
export * from "./flowchart-node.ts?vue&type=script&lang=ts&"
import style0 from "./flowchart-node.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports